import script from "./nonStockable.vue?vue&type=script&setup=true&lang=js"
export * from "./nonStockable.vue?vue&type=script&setup=true&lang=js"

import "./nonStockable.vue?vue&type=style&index=0&id=f282c1f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f282c1f2"]])

export default __exports__